import { render, staticRenderFns } from "./NextMoveJobZones.vue?vue&type=template&id=12bbc8aa&scoped=true"
import script from "./NextMoveJobZones.vue?vue&type=script&lang=ts"
export * from "./NextMoveJobZones.vue?vue&type=script&lang=ts"
import style0 from "./NextMoveJobZones.vue?vue&type=style&index=0&id=12bbc8aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bbc8aa",
  null
  
)

export default component.exports